import { z } from 'zod';

import { request } from '@/api/httpClient';

export type PeopleKind = 'technicians' | 'managers';
export interface Person {
  id: number;
  name: string;
  email: string;
}
export interface PersonInput {
  name: string;
  email: string;
  password: string;
  passwordConfirmation: string;
}
const schema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1),
  email: z.string().email(),
});
export async function getPeople(kind: PeopleKind): Promise<Person[]> {
  return z.array(schema).parse(await request<unknown>(`/managers/${kind}`));
}
export async function savePerson(kind: PeopleKind, value: PersonInput, id?: number) {
  const body: Record<string, string> = {
    name: value.name.trim(),
    email: value.email.trim().toLowerCase(),
  };
  if (value.password) {
    body.password = value.password;
    body.password_confirmation = value.passwordConfirmation;
  }
  return schema.parse(
    await request<unknown>(`/managers/${kind}${id ? `/${id}` : ''}`, {
      method: id ? 'PUT' : 'POST',
      body,
    }),
  );
}
export async function deletePerson(kind: PeopleKind, id: number) {
  await request(`/managers/${kind}/${id}`, { method: 'DELETE' });
}

const assignedClientSchema = z.object({
  id: z.number().int().positive(),
  service_location: z.object({
    id: z.number().int().positive(),
    name: z.string(),
    client: z.object({ id: z.number().int().positive(), name: z.string() }),
  }),
});
export type AssignedClient = z.infer<typeof assignedClientSchema>;
export async function getAssignedClients(technicianId: number): Promise<AssignedClient[]> {
  return z
    .array(assignedClientSchema)
    .parse(await request<unknown>(`/managers/technicians/${technicianId}/clients`));
}
